import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M2 18.005c0 .55.446.995.995.995h8.01a.995.995 0 1 0 0-1.99h-8.01a.995.995 0 0 0-.995.995M2 12c0 .55.446.995.995.995h18.01a.995.995 0 1 0 0-1.99H2.995A.995.995 0 0 0 2 12M3.421 7a1.77 1.77 0 0 1-1.005-.293C2.15 6.52 2 6.265 2 6s.15-.52.416-.707A1.77 1.77 0 0 1 3.421 5H20.58c.377 0 .738.105 1.005.293.266.187.416.442.416.707s-.15.52-.416.707A1.77 1.77 0 0 1 20.579 7z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }